import type { ServiceLocation } from "@/modules/shared/serviceLocation";

/**
 * What the booking widget's form holds before anything is chosen
 * (docs/ux/flows/consumer-booking.md).
 *
 * It is how the form opens and also what it goes back to once a request is
 * sent: the request has been made, and a form still holding its service, place
 * and address reads as one not yet sent. A refusal never comes here; re-picking
 * a time is the whole recovery from one.
 */
export interface BookingForm {
  serviceId: string;
  serviceLocation: ServiceLocation;
  homeAddress: string;
  picked: { date: string; startMinutes: number } | null;
}

export function initialBookingForm(
  services: { id: string }[],
  offeredLocations: ServiceLocation[],
): BookingForm {
  return {
    // Preselected, because a form that starts blank asks for a choice the
    // page has already made.
    serviceId: services[0]?.id ?? "",
    serviceLocation: offeredLocations[0] ?? "in_clinic",
    homeAddress: "",
    picked: null,
  };
}
